module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0076.png.13364c1c.jpg";